<template>
  <div>
    <Layout>
      <div class="containers">
        <div class="store" v-for=" (item,index) in storeList" :key="index">
          <p class="store_name">{{item.storeName}}</p>
          <p>{{item.storeSite}}</p>
        </div>
      </div>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/public/layout'
import config from '@/config'
export default {
  data() {
    return {
      storeList: config.pageData.stores
    };
  },
  methods: {
  },
  components: {
    Layout
  },
  created() {

  }
}

</script>

<style lang="less" rel="stylesheet/less" scoped>
  @import "index";
</style>
